import React from 'react';
import { HomeIcon } from '@heroicons/react/24/outline';
import PublicTourCard from './PublicTourCard';

const PublicAgencyTourGrid = ({
    tours,
    t,
    i18n,
    handleShare,
    handleWhatsAppShare,
    copiedId,
    cities,
    propertyTypes,
    defaultCurrency
}) => {
    return (
        <div className="flex-grow">
            <div className="mb-6">
                <h2 className="text-2xl font-bold text-textPrimary">{t('foundProperties', { count: tours.length })}</h2>
            </div>

            {tours.length === 0 ? (
                <div className="text-center py-16 bg-surface-glass backdrop-blur-xl rounded-2xl border-2 border-dashed border-gold/20">
                    <HomeIcon className="mx-auto h-16 w-16 text-textMuted" />
                    <h3 className="mt-4 text-lg font-medium text-textPrimary">{t('noToursFound')}</h3>
                    <p className="mt-2 text-sm text-textMuted">{t('noToursMatching')}</p>
                </div>
            ) : (
                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-2 xl:grid-cols-3 gap-4 sm:gap-6">
                    {(tours || []).map(tour => (
                        <PublicTourCard
                            key={tour.id}
                            tour={tour}
                            t={t}
                            i18n={i18n}
                            handleShare={handleShare}
                            handleWhatsAppShare={handleWhatsAppShare}
                            copiedId={copiedId}
                            cities={cities}
                            propertyTypes={propertyTypes}
                            defaultCurrency={defaultCurrency}
                        />
                    ))}
                </div>
            )}
        </div>
    );
};

export default PublicAgencyTourGrid;
